import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../../../api/api";
import "../../../../components/table.css";
import EditImg from "../../../../image/Edit.svg";
import Pagination from "../../../../components/Pagination";
import BackButton from "../../../../components/BackButton";

const ListOfUnverifiedUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await api.get("/unverified-users");
        console.log("response", response);

        setUsers(Array.isArray(response.data.users) ? response.data.users : []);
      } catch (error) {
        console.error("Failed to fetch users:", error);
        setUsers([]);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  // Pagination calculations
  const totalPages = Math.ceil(users.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = users.slice(startIndex, startIndex + itemsPerPage);

  const goToPage = (page) => {
    if (page < 1) page = 1;
    if (page > totalPages) page = totalPages;
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (num) => {
    setItemsPerPage(num);
    setCurrentPage(1);
  };

  return (
    <>
    <BackButton />
      {loading ? (
        <p>Loading users...</p>
      ) : (
        <>
         <div
            className={`table-responsive table-fixed-header overflow-auto  ${
              itemsPerPage >= 20 ? "mb-80" : itemsPerPage > 11 ? "mb-3" : ""
            }`}
          >
            <table
              className={`table table-bordered table-hover  ${
                itemsPerPage >= 20 ? "mb-3" : itemsPerPage < 11 ? "mb-0" : ""
              }`}
            >
              <thead className="table-light">
                <tr>
                  <th>Name</th>
                  <th>Company Name</th>
                  <th>GST Number</th>
                  <th>Status</th>
                  <th style={{ width: "150px" }} className="text-center">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentItems.length === 0 ? (
                  <tr>
                    <td colSpan="5" className="text-center">
                      No users found
                    </td>
                  </tr>
                ) : (
                  currentItems.map((user) => (
                    <tr key={user.user_id}>
                      <td>{user.full_name}</td>
                      <td>{user.company_name}</td>
                      <td>{user.gst_number}</td>
                      <td>{user.profile_status}</td>
                      <td>
                        <div className="d-flex gap-2 justify-content-center imgintbl">
                          <Link
                            to={`/admin/user/${user.user_id}/documents`}
                            title="View Documents"
                          >
                            <img
                              src={EditImg}
                              alt="View Documents"
                              width={20}
                              height={20}
                            />
                          </Link>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={goToPage}
            itemsPerPage={itemsPerPage}
            onItemsPerPageChange={handleItemsPerPageChange}
          />
        </>
      )}
    </>
  );
};

export default ListOfUnverifiedUsers;
